import axios from "axios";

export default {
  state: {
    quote: null
  },
  getters: {
    QUOTE: state => state.quote
  },
  mutations: {
    SET_QUOTE ( state, quote ) {
      state.quote = quote;
    },
  },
  actions: {
    GET_QUOTE: async ( context, quoteId ) => {
      context.commit('SET_QUOTE', false);
      let { data } = await axios.get( '/quotes/' + quoteId )
      context.commit('SET_QUOTE', typeof(data.result) != 'undefined'? data.result: data);
      return typeof(data.result) != 'undefined'? data.result: data;
    },
    UPDATE_QUOTE ( { commit }, quote ) {
      commit( 'SET_QUOTE', quote );
    }
  },
}
